import React from "react";
import {App} from "../App/App";
import {useNavigate, useParams} from "react-router-dom";
import {demo01} from "./demo01";
import {demo02} from "./demo02";
import {demo03} from "./demo03";
import {ProgressProvider} from "../progress/progressContext";
import {demo05} from "./demo05";
import {demo06} from "./demo06";
import {demo07_pionerkultur} from "./demo07_pionerkultur";
import {demo08_teknisk_kommunikasjon} from "./demo08_teknisk_kommunikasjon";
import {demo09_nordsjodykking} from "./demo09_nordsjodykking";
import {demo10_boring} from "./demo10_boring";
import {demo11_ken_burns} from "./demo11_ken_burns";

export const ScrollyDemo = () => {
    const {id} = useParams();
    const navigate = useNavigate();

    return (
        <ProgressProvider>
            <App
                data={scrollys[id] ? { ...scrollys[id], autoplay: { enabled: true }, audioGuide: { enabled: true } } : undefined}
                adminMode={false}
                onClose={() => navigate("/")}
            />
        </ProgressProvider>
    )
};
const scrollys = {
    1: demo01,
    2: demo02,
    3: demo03,
    5: demo05,
    6: demo06,
    7: demo07_pionerkultur,
    8: demo08_teknisk_kommunikasjon,
    9: demo09_nordsjodykking,
    10: demo10_boring,
    11: demo11_ken_burns,
};
